import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

import Dropzone from "../classes/Dropzone";
import Validation from '../classes/Validation';

import DropzoneFlat from "../dropzone/flat";

import _MASK_FLAT from './../Const/Masks/_FLAT';
import _MASK_FLOOR from './../Const/Masks/_FLOOR';
import _MASK_SECTION from './../Const/Masks/_SECTION';
import _MASK_BUILDING from './../Const/Masks/_BUILDING';
import _MASK_OBJECT from './../Const/Masks/_OBJECT';

class Flat {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $modal : $(),
        $form  : $()
    };

    _const = {
        entities : 'flats',
        entity   : 'flat',
        title : {
            add  : 'Добавление новой секции',
            edit : 'Редактирование секции'
        },
        parent : {
            entities : 'sections',
            entity   : 'section',
            parent   : {
                entities : 'buildings',
                entity   : 'building',
                parent   : {
                    entities : 'objects',
                    entity   : 'object',
                }
            }
        }
    };

    _state = {
        dropzone : {}
    };

    _args = {
        item      : {},
        items     : {},
        section   : {},
        building  : {},
        object    : {},
        group     : null,
        main_item : {},
        progress  : {},
        done      : function () {}
    };

    _utils = {
        validation : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.item      = args.item || self._args.item;
        self._args.items     = args.items || self._args.items;
        self._args.section   = args.section || self._args.section;
        self._args.building  = args.building || self._args.building;
        self._args.object    = Object.keys(self._args.building).length && self._args.building.object ? self._args.building.object : self._args.object;

        self._args.group     = args.group || self._args.group;
        self._args.main_item = args.main_item || self._args.main_item;
        self._args.done      = args.done || self._args.done;

        self._args.progress  = args.progress || self._args.progress;
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _setDropzone = () => {
        let self = this;

        self._state.dropzone.items = DropzoneFlat.get({
            item     : self._args.item,
            parent1  : self._args.object,
            parent2  : self._args.building,
            parent3  : self._args.section,
            entities : self._const.entities
        });
        self._state.dropzone.entity = self._args.item;
    };

    _bindConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        loader.increase();

        Request.send({
            path: 		'/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/sections/' + self._args.section.id + '/flats/' + (Object.keys(self._args.item).length ? 'edit' : 'create'),
            method: 	'POST',
            data: $form.serialize() + '&' + $.param(Object.keys(self._args.item).length ? {
                flats: self._args.items[0].flats.map(function(flat) {
                    return { id: flat.id };
                })
            } : {
                flats: self._args.items[0].flats.map(function(flat) {
                    return {
                        floor_id: 		self._args.section.floors[flat.floor_index].id,
                        column_index: 	flat.column_index
                    };
                }),
                group: self._args.group,
                main_flat: Object.keys(self._args.main_item).length ? {
                    floor_id: 		self._args.section.floors[self._args.main_item.floor_index].id,
                    column_index: 	self._args.main_item.column_index
                } : null
            }),
            done: function(response) {
                loader.decrease();
                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return;
                }

                $modal.trigger('close');

                self._args.done && self._args.done(response);
                self._args.progress.update({
                    object : self._args.object
                });
            }
        });
    };

    _initModal = () => {
        let self = this;

        self._elems.$modal = new Modal({
            title: (Object.keys(self._args.item).length ? 'Редактирование помещений' : (self._args.group ? 'Добавление объединенных помещений' : 'Добавление помещений')),
            content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                common_flat : Object.keys(self._args.item).length ? self._args.item : null,
                object      : self._args.object,
                building    : self._args.building,
                masks       : {
                    _FLAT     : _MASK_FLAT,
                    _FLOOR    : _MASK_FLOOR,
                    _SECTION  : _MASK_SECTION,
                    _BUILDING : _MASK_BUILDING,
                    _OBJECT   : _MASK_OBJECT
                }
            }),
            confirm : function(args) {
                self._bindConfirm(args);
            },
            closingConfirmation: true,
            dropzone : self._state.dropzone
        });

        self._elems.$form = self._elems.$modal.find('#' + self._const.entity + '-form');
        self._elems.$form.find('input, select').eq(0).focus();

        let $description = self._elems.$form.find('[data-name="description"]');
        if ($description.length) {
            let $textarea = $description.find('textarea');
            $description.find('[data-mask]').click(function(e){
                e.preventDefault();
                $textarea.val($textarea.val() + $(this).data('mask') + ' ').focus();
            });
            self._elems.$form.find('.form-field__masks .title a.open').click(function(e){
                e.preventDefault();

                self._elems.$form.find('.form-field__masks .masks').slideToggle();
            });
            self._elems.$form.find('.form-field__masks .title a.info').click(function(e){
                e.preventDefault();

                new Modal({
                    title   : 'Информация о масках',
                    content : Utils.renderProfileTemplate(self._const.entity + '-masks-info'),
                    confirm : function(args) {
                        args.modal.trigger('close');
                    }
                });
            });
        }

        self._setValidation();

        self._updateForm();
        self._updateFormPrice();
        self._updateFormMonthlyPrice();

        self._elems.$form.find('select[name="flat[type]"]').on('change', function() {
            self._updateForm();

            if (!Object.keys(self._args.item).length && $(this).val() == 'office') {
                self._elems.$form.find('.form-field[data-name="count_of_rooms"] select option').prop('selected', false);
                self._elems.$form.find('.form-field[data-name="count_of_rooms"] select option').eq(0).prop('selected', true);
            }
        });
        self._elems.$form.find('select[name="flat[commerce_type]"]').on('change', function() {
            self._updateForm();
        });
        self._elems.$form.find('select[name="flat[count_of_rooms]"]').on('change', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="is_free_layout"] .checkbox').on('change', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="sale_price"] input').on('keyup', function() {
            self._updateFormPrice();
        });
        self._elems.$form.find('.form-field[data-name="rent_price"] input').on('keyup', function() {
            self._updateFormMonthlyPrice();
        });
        self._elems.$form.find('select[name="flat[price_type]"]').on('change', function() {
            self._updateFormPrice();
        });
        self._elems.$form.find('select[name="flat[monthly_price_type]"]').on('change', function() {
            self._updateFormMonthlyPrice();
        });
        self._elems.$form.find('input[name="flat[total_area]"]').on('keyup', function() {
            self._updateFormPrice();
            self._updateFormMonthlyPrice();
        });
        self._elems.$form.find('.form-field[data-name="has_action"] .checkbox').on('change', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="has_action"] .checkbox').on('disable', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="has_action"] .checkbox').on('enable', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field .checkbox-flat-price').on('change', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field .checkbox-flat-price').on('disable', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field .checkbox-flat-price').on('enable', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field .checkbox-flat-monthly_price').on('change', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field .checkbox-flat-monthly_price').on('disable', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field .checkbox-flat-monthly_price').on('enable', function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="commerce_type_additional"] .checkbox__enable').on('click', function(e){
            e.preventDefault();
            $(this).parents('.checkbox-list').removeClass('disabled');
            self._elems.$form.find('.form-field[data-name="commerce_type"] .select').removeClass('disabled');
            self._elems.$form.find('.form-field[data-name="commerce_type"] .select select').removeAttr('disabled');
            self._elems.$form.find('.form-field[data-name="commerce_type_additional"] .checklist-item').each(function(){
                $(this).removeClass('disabled');
                $(this).children('input').removeAttr('disabled');
            });
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="commerce_type_additional"] .checkbox__disable').on('click', function(e){
            e.preventDefault();
            $(this).parents('.checkbox-list').addClass('disabled');
            self._elems.$form.find('.form-field[data-name="commerce_type"] .select').addClass('disabled');
            self._elems.$form.find('.form-field[data-name="commerce_type"] .select select').attr('disabled', 'disabled');
            self._elems.$form.find('.form-field[data-name="commerce_type_additional"] .checklist-item').each(function(){
                $(this).addClass('disabled').removeClass('checked');
                $(this).children('input').val('').attr('disabled', 'disabled');
            });
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="prices"] .checkbox__enable').on('click', function(e){
            e.preventDefault();
            if($(this).parent().hasClass('form-group__sections')){
                var $parent = $(this).parent();
                $parent.removeClass('disabled');
                $parent.find('.input').removeClass('disabled');
                $parent.find('.input input').removeAttr('disabled');
                $parent.find('.select').removeClass('disabled');
                $parent.find('.select select').removeAttr('disabled');
            }
            else {
                $(this).parents('.checkbox-list').removeClass('disabled');
                $(this).parents('.checkbox-list').children('.checkbox').removeClass('disabled');
                $(this).parents('.checkbox-list').find('.checkbox input').removeAttr('disabled');
            }
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="prices"] .checkbox__disable').on('click', function(e){
            e.preventDefault();
            if ($(this).parent().hasClass('form-group__sections')){
                let $parent = $(this).parent();
                $parent.addClass('disabled');
                $parent.find('.input').addClass('disabled');
                $parent.find('.input input').val('').attr('disabled', 'disabled');
                $parent.find('.select').addClass('disabled');
                $parent.find('.select select').attr('disabled', 'disabled');
            }
            else {
                $(this).parents('.checkbox-list').addClass('disabled');
                $(this).parents('.checkbox-list').children('.checkbox').addClass('disabled');
                $(this).parents('.checkbox-list').find('.checkbox input').attr('disabled', 'disabled');

                let $group = $(this).parents('.checkbox-list').next('.form-group').find('.form-group__sections');
                $group.addClass('disabled');
                $group.find('.input').addClass('disabled');
                $group.find('.input input').attr('disabled', 'disabled');
                $group.find('.select').addClass('disabled');
                $group.find('.select select').attr('disabled', 'disabled');
            }
            self._updateForm();
        });

        if (!Object.keys(self._args.item).length || self._args.item.images) {
            self._setDropzone();

            self._elems.$form.find('.dropzone').each(function(){
                // self._setDropzone();
                new Dropzone({
                    root   : $(this),
                    form   : self._elems.$form,
                    items  : self._state.dropzone.items,
                    entity : self._const.entity
                })
            });
        } else {
            self._elems.$form.find('.dropzone .dz-unblock').click(function(e) {
                e.preventDefault();
                self._elems.$form.find('.dropzone .dz-default.dz-message').remove();
                self._elems.$form.find('input[name="flat[with_images]"]').prop('disabled', false);
                self._args.item.images = [];

                self._elems.$form.find('.dropzone').each(function(){
                    self._setDropzone();
                    new Dropzone({
                        root   : $(this),
                        form   : self._elems.$form,
                        items  : self._state.dropzone.items,
                        entity : self._const.entity
                    })
                });

                return false;
            });
        }
    };

    _updateForm = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        const checks = {
            type: 					self._elems.$form.find('select[name="flat[type]"]').val(),
            is_studio: 				self._elems.$form.find('select[name="flat[count_of_rooms]"]:not(:disabled)').length
                                        ? self._elems.$form.find('select[name="flat[count_of_rooms]"]').val() == '0'
                                        : null,
            is_free_layout: 		self._elems.$form.find('.form-field[data-name="is_free_layout"] .checkbox:not(.disabled)').length
                                        ? self._elems.$form.find('.form-field[data-name="is_free_layout"] .checkbox').hasClass('checked')
                                        : null,
            count_of_rooms: 		parseInt(self._elems.$form.find('select[name="flat[count_of_rooms]"]').val()),
            commerce_type:       	self._elems.$form.find('select[name="flat[commerce_type]"]').val(),
            has_action_disabled: 	self._elems.$form.find('.form-field[data-name="has_action"] .checkbox').hasClass('disabled'),
            has_action: 			self._elems.$form.find('.form-field[data-name="has_action"] .checkbox').hasClass('checked'),
            is_sale_disabled:       self._elems.$form.find('.form-field[data-name="prices"] .checkbox.checkbox-flat-price').hasClass('disabled'),
            is_sale:                self._elems.$form.find('.form-field[data-name="prices"] .checkbox.checkbox-flat-price').hasClass('checked'),
            is_rent_disabled:       self._elems.$form.find('.form-field[data-name="prices"] .checkbox.checkbox-flat-monthly_price').hasClass('disabled'),
            is_rent:                self._elems.$form.find('.form-field[data-name="prices"] .checkbox.checkbox-flat-monthly_price').hasClass('checked')
        };

        let selected_unique_flats = self._args.items[0].flats.filter(function(selected_flat) {
            let flat = self._args.section.flats.filter(function(flat) {
                return selected_flat.id == flat.id;
            }).pop() || null;
            return !flat || !flat.group || flat.group.main_flat_id == flat.id;
        });

        if (['flat', 'apartment'].indexOf(checks.type) !== -1) {
            //self._elems.$form.find('.form-field[data-name="number"]').hide();
            self._elems.$form.find('.form-field[data-name="commerce_type"]').hide();
            self._elems.$form.find('.form-field[data-name="commerce_type_additional"]').hide();

            self._elems.$form.find('select[name="flat[count_of_rooms]"] option[value="0"]').prev().prop('disabled', true).prop('selected', false).hide();
            if (checks.is_free_layout === true) {
                self._elems.$form.find('select[name="flat[count_of_rooms]"] option[value="0"]').prop('disabled', true).prop('selected', false).hide();
            }
            else {
                self._elems.$form.find('select[name="flat[count_of_rooms]"] option[value="0"]').prop('disabled', false).show();
            }

            self._elems.$form.find('.form-field[data-name="count_of_rooms"]').addClass('required').show();
            self._elems.$form.find('.form-field[data-name="living_area"]').show();
            self._elems.$form.find('.form-field[data-name="kitchen_area"]').show();

            if (checks.is_free_layout || checks.is_free_layout == null || checks.is_studio || checks.is_studio == null || checks.count_of_rooms == 1 || isNaN(checks.count_of_rooms)) {
                self._elems.$form.find('.form-group[data-name="each_room_area"]').hide();
                self._elems.$form.find('.form-group[data-name="each_room_area"] [name="flat[each_room_area][]"]').each(function(){
                    $(this).attr('disabled', 'disabled');
                })
            }
            else {
                self._elems.$form.find('.form-group[data-name="each_room_area"]').show();
                self._elems.$form.find('.form-group[data-name="each_room_area"] .form-group__section').slice(0, checks.count_of_rooms).show();
                self._elems.$form.find('.form-group[data-name="each_room_area"] .form-group__section').slice(checks.count_of_rooms).hide();

                self._elems.$form.find('.form-group[data-name="each_room_area"] [name="flat[each_room_area][]"]').each(function(){
                    $(this).removeAttr('disabled');
                })
            }

            self._elems.$form.find('.form-field[data-name="count_of_separated_bathrooms"]').show();
            self._elems.$form.find('.form-field[data-name="count_of_separated_bathrooms"] .form-field__title').text('Количество раздельных санузлов');
            self._elems.$form.find('.form-field[data-name="count_of_combained_bathrooms"]').show();
            self._elems.$form.find('.form-field[data-name="count_of_balconies"]').show();
            self._elems.$form.find('.form-field[data-name="count_of_loggias"]').show();
            self._elems.$form.find('.form-field[data-name="has_own_entrance_group"]').hide();

            if (checks.is_studio || checks.is_studio == null) {
                self._elems.$form.find('.form-field[data-name="is_free_layout"]').hide();
            }
            else {
                self._elems.$form.find('.form-field[data-name="is_free_layout"]').show();
            }

            self._elems.$form.find('.form-group[data-name="windows_overlook"]').show();
            self._elems.$form.find('.form-field[data-name="total_area"] .form-field__title').text('Общая площадь');
            self._elems.$form.find('.form-field[data-name="total_area"] .input input').attr('placeholder', 'Укажите общую площадь');
            self._elems.$form.find('.form-group[data-name="monthly_price"]').hide();
            self._elems.$form.find('.form-field[data-name="is_penthouse"]').show();
            self._elems.$form.find('.form-field[data-name="front_door_material"]').show();
            self._elems.$form.find('.form-field[data-name="has_intercom"]').show();

            if (checks.is_free_layout || checks.is_studio || checks.is_studio == null || checks.count_of_rooms == 1) {
                self._elems.$form.find('.form-group[data-name="rooms_are"]').hide();
            }
            else {
                self._elems.$form.find('.form-group[data-name="rooms_are"]').show();
            }
        }
        else if (checks.type == 'office') {
            if (Object.keys(self._args.item).length && checks.type == 'office' && selected_unique_flats.length == 1 && self._args.item.number !== null) {
                self._elems.$form.find('.form-field[data-name="number"]').show();
                self._elems.$form.find('.form-field[data-name="number"] .input input').text(self._args.item.number);
            }
            else if (!Object.keys(self._args.item).length && selected_unique_flats.length == 1) {
                self._elems.$form.find('.form-field[data-name="number"]').show();
            }
            else {
                self._elems.$form.find('.form-field[data-name="number"]').hide();
            }

            if (checks.commerce_type == 'extra') {
                self._elems.$form.find('.form-field[data-name="commerce_type"] .input').show();
            }
            else {
                self._elems.$form.find('.form-field[data-name="commerce_type"] .input').hide();
            }

            self._elems.$form.find('.form-field[data-name="commerce_type"]').show();
            if(!self._elems.$form.find('.form-field[data-name="commerce_type"] .select').hasClass('disabled') || selected_unique_flats.length == 1) {
                if(selected_unique_flats.length == 1) {
                    self._elems.$form.find('.form-field[data-name="commerce_type"] .select').removeClass('disabled');
                }
                if(checks.commerce_type == '') {
                    self._elems.$form.find('.form-field[data-name="commerce_type"] select').val('office').trigger('change').removeAttr('disabled');
                    checks.commerce_type = 'office';
                }
            }
            else {
                self._elems.$form.find('.form-field[data-name="commerce_type"] select').attr('disabled', 'disabled');
            }

            self._elems.$form.find('.form-field[data-name="commerce_type_additional"]').show();
            self._elems.$form.find('.form-field[data-name="commerce_type_additional"] .checklist-item').each(function(){
                let $item = $(this);
                if ($item.children('input').val() == checks.commerce_type){
                    $item.removeClass('checked').hide();
                    $item.children('input').attr('disabled', 'disabled');
                }
                else {
                    $item.show();
                }

                if ($item.hasClass('checked')) {
                    $item.children('input').removeAttr('disabled');
                }
                else {
                    $item.children('input').attr('disabled', 'disabled');
                }
            });

            self._elems.$form.find('select[name="flat[count_of_rooms]"] option[value="0"]').prev().prop('disabled', false).show();
            self._elems.$form.find('select[name="flat[count_of_rooms]"] option[value="0"]').prop('disabled', true).prop('selected', false).hide();
            self._elems.$form.find('.form-field[data-name="count_of_rooms"]').removeClass('required').show();
            self._elems.$form.find('.form-field[data-name="living_area"]').hide();
            self._elems.$form.find('.form-field[data-name="kitchen_area"]').hide();

            if (checks.is_free_layout || checks.is_free_layout == null || checks.count_of_rooms == 0 || checks.count_of_rooms == 1 || isNaN(checks.count_of_rooms)) {
                self._elems.$form.find('.form-group[data-name="each_room_area"]').hide();
            }
            else {
                self._elems.$form.find('.form-group[data-name="each_room_area"]').show();
                self._elems.$form.find('.form-group[data-name="each_room_area"] .form-group__section').slice(0, checks.count_of_rooms).show();
                self._elems.$form.find('.form-group[data-name="each_room_area"] .form-group__section').slice(checks.count_of_rooms).hide();
            }

            self._elems.$form.find('.form-field[data-name="count_of_separated_bathrooms"]').show();
            self._elems.$form.find('.form-field[data-name="count_of_separated_bathrooms"] .form-field__title').text('Количество санузлов');
            self._elems.$form.find('.form-field[data-name="count_of_combained_bathrooms"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_balconies"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_loggias"]').hide();
            self._elems.$form.find('.form-field[data-name="has_own_entrance_group"]').show();
            self._elems.$form.find('.form-field[data-name="is_free_layout"]').show();
            self._elems.$form.find('.form-group[data-name="windows_overlook"]').hide();
            self._elems.$form.find('.form-field[data-name="total_area"] .form-field__title').text('Площадь');
            self._elems.$form.find('.form-field[data-name="total_area"] .input input').attr('placeholder', 'Укажите площадь');
            self._elems.$form.find('.form-group[data-name="monthly_price"]').show();
            self._elems.$form.find('.form-field[data-name="is_penthouse"]').hide();
            self._elems.$form.find('.form-group[data-name="rooms_are"]').hide();
            self._elems.$form.find('.form-field[data-name="front_door_material"]').hide();
            self._elems.$form.find('.form-field[data-name="has_intercom"]').hide();
        }
        else {
            self._elems.$form.find('.form-field[data-name="number"]').hide();
            self._elems.$form.find('.form-field[data-name="commerce_type"]').hide();
            self._elems.$form.find('.form-field[data-name="commerce_type_additional"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_rooms"]').hide();
            self._elems.$form.find('.form-field[data-name="living_area"]').hide();
            self._elems.$form.find('.form-field[data-name="kitchen_area"]').hide();
            self._elems.$form.find('.form-group[data-name="each_room_area"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_separated_bathrooms"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_combained_bathrooms"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_balconies"]').hide();
            self._elems.$form.find('.form-field[data-name="count_of_loggias"]').hide();
            self._elems.$form.find('.form-field[data-name="has_own_entrance_group"]').hide();
            self._elems.$form.find('.form-field[data-name="is_free_layout"]').hide();
            self._elems.$form.find('.form-group[data-name="windows_overlook"]').hide();
            self._elems.$form.find('.form-field[data-name="total_area"] .form-field__title').text('Площадь');
            self._elems.$form.find('.form-field[data-name="total_area"] .input input').attr('placeholder', 'Укажите площадь');
            // self._elems.$form.find('.form-group[data-name="monthly_price"]').hide();
            self._elems.$form.find('.form-field[data-name="is_penthouse"]').hide();
            self._elems.$form.find('.form-group[data-name="rooms_are"]').hide();
            self._elems.$form.find('.form-field[data-name="front_door_material"]').hide();
            self._elems.$form.find('.form-field[data-name="has_intercom"]').hide();
        }

        self._elems.$form.find('.form-field[data-name="has_action"]').show();

        if (!checks.has_action_disabled && checks.has_action) {
            self._elems.$form.find('.form-field[data-name="action_description"]').show();
        }
        else {
            self._elems.$form.find('.form-field[data-name="action_description"]').hide();
        }

        if (!checks.is_sale_disabled && checks.is_sale) {
            self._elems.$form.find('.form-group[data-name="price"]').show();
        }
        else {
            self._elems.$form.find('.form-group[data-name="price"]').hide();
        }

        if (!checks.is_rent_disabled && checks.is_rent) {
            self._elems.$form.find('.form-group[data-name="monthly_price"]').show();
        }
        else {
            self._elems.$form.find('.form-group[data-name="monthly_price"]').hide();
        }

        if (selected_unique_flats.length == 1) {
            self._elems.$form.find('.form-field[data-name="number"]').show();
        }
        else {
            self._elems.$form.find('.form-field[data-name="number"]').hide();
        }
    };

    _updateFormPrice = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let $field       = self._elems.$form.find('[data-name="sale_price"]');
        let $input       = $field.find('input');
        const value      = $input.val().replace(/\s+/g, '');
        const priceType  = self._elems.$form.find('select[name="flat[price_type]"]').val();
        const totalArea  = self._elems.$form.find('input[name="flat[total_area]"]').val();

        $field.find('.form-field__description').hide();

        if (priceType == 'total') {
            $input.attr('name', 'flat[price]');

            if(value && parseFloat(value) > 0 && totalArea && parseFloat(totalArea) > 0) {
                var price = Math.round(parseFloat(value) / parseFloat(totalArea) * 100) / 100;
                $field.find('.form-field__description').text('Цена за 1 кв.м.: ' + String(price).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') + ' руб.').show();
            }
        }
        else if (priceType == 'square-meter') {
            $input.attr('name', 'flat[price_per_square_meter]');

            if(value && parseFloat(value) > 0 && totalArea && parseFloat(totalArea) > 0) {
                var price = Math.round(parseFloat(value) * parseFloat(totalArea) * 100) / 100;
                $field.find('.form-field__description').text('Цена за всё: ' + String(price).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') + ' руб.').show();
            }
        }
    };

    _updateFormMonthlyPrice  = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let $field       = self._elems.$form.find('[data-name="rent_price"]');
        let $input       = $field.find('input');
        let $description = $field.find('.form-field__description');
        const value      = $input.val().replace(/\s+/g, '');
        const priceType  = self._elems.$form.find('select[name="flat[monthly_price_type]"]').val();
        const totalArea  = self._elems.$form.find('input[name="flat[total_area]"]').val();

        if (priceType == 'total') {
            $input.attr('name', 'flat[monthly_price]');

            if (value && parseFloat(value) > 0 && totalArea && parseFloat(totalArea) > 0) {
                let price = Math.round(parseFloat(value) / parseFloat(totalArea) * 100) / 100;
                $description.text('Цена в мес. за 1 кв.м.: ' + String(price).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') + ' руб.').show();
            }
        }
        else if (priceType == 'square-meter') {
            $input.attr('name', 'flat[monthly_price_per_square_meter]');

            if (value && parseFloat(value) > 0 && totalArea && parseFloat(totalArea) > 0) {
                let price = Math.round(parseFloat(value) * parseFloat(totalArea) * 100) / 100;
                $description.text('Цена в мес. за всё: ' + String(price).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ') + ' руб.').show();
            }
        }
    };

    _bindUI = () => {
        let self = this;

        self._initModal();
    };

    _init = () => {
        let self = this;

        self._bindUI();

    }
}

export default Flat;